var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop } from 'vue-property-decorator';
import VueDialog from "../../../../interface/IVueDialog";
import LeftTree from './LeftTree.vue';
import TabTable from './TableCommon.vue';
import _ from 'lodash';
var EActiveType;
(function (EActiveType) {
    EActiveType["UN_SELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var statusMap = {
    0: '待审核',
    1: '已审核',
    6: '已废弃',
};
var timeTypeMap = {};
var AddGoods = (function (_super) {
    __extends(AddGoods, _super);
    function AddGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabTableComponent = 'tab-table';
        _this.total = 0;
        _this.pagerCount = 5;
        _this.curGoodNode = {};
        _this.activeName = '0';
        _this.selectRows = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.formData = {};
        _this.form = {};
        _this.unSelectList = [];
        _this.tableColumnList = [
            { "prop": "delivery_order_code", "propName": "送货单号" },
            { "prop": "delivery_order_status", "propName": "状态", columnRender: function (row) {
                    return statusMap[row.delivery_order_status] || '';
                } },
            { "prop": "business_name", "propName": "客户" },
            { "prop": "shop_name", "propName": "门店" },
            { "prop": "delivery_time", "propName": "送货时间" },
        ];
        _this.page = {
            pageNo: 1,
            limit: 10,
            sizes: [10, 50, 100],
            total: 4
        };
        _this.timeTypeList = [
            { value: 1, label: '送货时间', field: 'delivery_time' },
            { value: 2, label: '到货时间', field: 'expect_arrivedate' },
            { value: 3, label: '生成时间', field: 'c_time' },
            { value: 4, label: '审核时间', field: 'order_atime' },
        ];
        return _this;
    }
    AddGoods.prototype.created = function () {
        console.log('this.tabTableComponent');
        console.log(this.tabTableComponent);
        if (this.type == 'entrust') {
            this.tableColumnList[0] = { "prop": "delivery_order_code", "propName": "委托送货单号" };
        }
        this.selectedList = _.cloneDeep(this.selectedNote ? this.selectedNote : []);
        this.gitRightList();
    };
    AddGoods.prototype.mounted = function () {
    };
    AddGoods.prototype.gitRightList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var goods_ids = (this.selectedList || []).map(function (item) {
            return item.delivery_order_id;
        });
        if (this.type == 'entrust') {
        }
        var param = Object.assign({
            not_in: String(goods_ids)
        }, this.searchData, this.param, pager);
        console.log('gitRightList>>>', param);
        this.url(param).then(function (res) {
            console.log(44555, res.data);
            if (res.data.success) {
                if (res.data.data.length == 0 && pager.page > 1) {
                    _this.search();
                    return;
                }
                _this.unSelectList = res.data.data;
                _this.total = res.data.total;
                _this.setSelected(true);
            }
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddGoods.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        if (!this.canFreshTable)
            return;
        this.canFreshTable = false;
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), 'order_detail_id');
        var isUnselectAll = !currentSelectRows.length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, function (good) { return good.order_detail_id === currentRow.order_detail_id; })) {
            _.remove(this.selectedList, function (good) { return good.order_detail_id === currentRow.order_detail_id; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.SELECTED) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (good) {
                _.remove(_this.selectedList, function (item) { return item.order_detail_id === good.order_detail_id; });
            });
        }
        setTimeout(function () {
            _this.canFreshTable = true;
            var pagination = _this.$refs.pagination;
            _this.gitRightList(pagination.getPage());
        });
    };
    AddGoods.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid.$refs.table;
        if (isUnSelFresh) {
            gridTable.clearSelection();
        }
        if (!this.selectedList.length) {
            this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.selectedList.forEach(function (good, index) {
                _this.$nextTick(function () {
                    _this.$refs.alreadyGrid.$refs.table.toggleRowSelection(good, true);
                });
                if (isUnSelFresh) {
                    var item_1 = _.find(_this.unSelectList, function (current) { return current.order_detail_id === good.order_detail_id; });
                    _this.$nextTick(function () {
                        gridTable.toggleRowSelection(item_1, true);
                    });
                }
            });
        }
    };
    AddGoods.prototype.search = function () {
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.gitRightList();
    };
    AddGoods.prototype.close = function () {
        this.$emit('closeDiolog', false);
    };
    AddGoods.prototype.save = function () {
        var data = _.uniqBy(this.selectedList, 'order_detail_id');
        this.$emit('save', data);
        this.$emit('closeDiolog', false);
    };
    AddGoods.prototype.pageChange = function (pager) {
        this.gitRightList(pager);
        this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
    };
    AddGoods.prototype.handleSizeChange = function (val) {
        console.log("\u6BCF\u9875 " + val + " \u6761");
    };
    AddGoods.prototype.handleCurrentChange = function (val) {
        console.log("\u5F53\u524D\u9875: " + val);
    };
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], AddGoods.prototype, "deliverNodeVisible", void 0);
    __decorate([
        Prop({
            type: String
        })
    ], AddGoods.prototype, "title", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], AddGoods.prototype, "FormModel", void 0);
    __decorate([
        Prop({
            type: Object
        })
    ], AddGoods.prototype, "searchData", void 0);
    __decorate([
        Prop({
            type: Function
        })
    ], AddGoods.prototype, "url", void 0);
    __decorate([
        Prop({
            type: Object
        })
    ], AddGoods.prototype, "param", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], AddGoods.prototype, "selectedNote", void 0);
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], AddGoods.prototype, "type", void 0);
    AddGoods = __decorate([
        Component({
            components: {
                'left-tree': LeftTree,
                'tab-table': TabTable,
            },
            computed: {
                columns: function () {
                    var _a = this, tableColumnList = _a.tableColumnList, time_type = _a.searchData.time_type, timeTypeList = _a.timeTypeList;
                    var newList = _.cloneDeep(tableColumnList);
                    var timeType = timeTypeList.find(function (i) { return i.value === time_type; });
                    if (timeType && timeType.field) {
                        var lastColumn = newList.pop();
                        lastColumn.prop = timeType.field;
                        lastColumn.propName = timeType.label;
                        newList.push(lastColumn);
                    }
                    return newList;
                }
            }
        })
    ], AddGoods);
    return AddGoods;
}(VueDialog));
export default AddGoods;
